// This file is generated by the openedx/frontend-platform's "intl-import.js" script.
//
// Refer to the i18n documents in https://docs.openedx.org/en/latest/developers/references/i18n.html to update
// the file and use the Micro-frontend i18n pattern in new repositories.
//

import messagesFromFrontendComponentFooter from './messages/frontend-component-footer';
import messagesFromParagon from './messages/paragon';
import messagesFromFrontendEnterprise from './messages/frontend-enterprise';
import messagesFromFrontendAppLearnerPortalEnterprise from './messages/frontend-app-learner-portal-enterprise';

export default [
  messagesFromFrontendComponentFooter,
  messagesFromParagon,
  messagesFromFrontendEnterprise,
  messagesFromFrontendAppLearnerPortalEnterprise,
];
